<template>
  <div class="content-430">
    <div class="class-form-head">课程信息</div>
    <div class="class-form-content">
      <Form
        ref="courseInfo"
        :model="courseInfo"
        label-position="right"
        :label-width="120"
        :rules="courseInfoRule"
        @on-validate="getFormValidate"
      >
        <FormItem
          v-if="portOrg != 2 && (classroomId === '' || (classroomId && isCopy))"
          label="发布学校"
          prop="schoolId"
        >
          <ChooseSchoolForForm
            v-model="selectSchoolData"
            @postSchoolRow="getSelectSchoolRow"
          ></ChooseSchoolForForm>
        </FormItem>
        <FormItem v-else label="发布学校" prop="schoolId">
          {{ courseInfo.schoolName }}
        </FormItem>
        <FormItem label="指定校区" prop="branchId">
          <Select
            v-model="courseInfo.branchId"
            :disabled="classroomId && !isCopy ? true : false"
            class="class-form-item"
            @on-change="getBranchName"
          >
            <Option
              v-for="item in campusList"
              :key="item.branchId"
              :value="item.branchId"
            >{{ item.branchName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="当前学期" prop="termCode">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            class="class-form-item"
            :placeholder="`请选择学期`"
            :need-init-data="false"
            :clearable="true"
            :disabled-year-term="!!(classroomId && !isCopy)"
            @on-change="getTermChange"
            @getSelectTermName="getTermName"
          ></CascaderYearTerms>
          <!-- <Select
            v-model="courseInfo.termId"
            class="class-form-item"
            :disabled="classroomId && !isCopy ? true : false"
            @on-change="getTermName"
          >
            <Option
              v-for="item in semesterList"
              :key="item.termId"
              :value="item.termId"
            >{{ item.yearName + item.termName }}</Option>
          </Select> -->
        </FormItem>
        <FormItem label="课程资源" prop="courseId">
          <div v-if="courseInfo.courseId" class="data-line">
            <span class="data-font">{{ courseInfo.courseName }}</span>
            <span
              v-if="classroomId === '' || (classroomId && isCopy)"
              class="change-btn"
              @click="handleOpenCourse(selectCourseGoodsData.courseId)"
            >更换关联商品</span>
          </div>
          <div
            v-else-if="classroomId === '' || (classroomId && isCopy)"
            class="class-add-btn"
            @click="handleOpenCourse"
          >
            选择课程
          </div>
        </FormItem>
        <div
          v-if="courseInfo.courseId"
          class="class-info-block"
          @click="handleToCourseTypePage"
        >
          <div class="class-info-item">
            <span>课程资源ID：</span>
            <span>{{ selectCourseGoodsData.courseId }}</span>
          </div>
          <div class="class-info-item">
            <span>课程类别：</span>
            <span>{{ selectCourseGoodsData.courseTypeName || '-' }}</span>
          </div>
          <div class="class-info-item">
            <span>课程提供方：</span>
            <span>{{ selectCourseGoodsData.orgName || '-' }}</span>
          </div>
        </div>

        <FormItem label="商品名称" prop="classroomName">
          <Input
            v-model="courseInfo.classroomName"
            class="class-form-item"
            placeholder="请填写商品名称"
            @on-blur="handleTrimValue('classroomName')"
          ></Input>
        </FormItem>
        <FormItem label="课程分类" prop="courseTypeId">
          <div
            v-if="!courseInfo.courseId"
            class="ivu-input class-form-item"
            @click="hanldCourse"
          ></div>
          <Cascader
            v-else-if="courseTypeIdShow"
            ref="cascaderBox"
            v-model="courseInfo.courseTypeId"
            :change-on-select="changeOnSelect"
            :data="courseTypeListData"
            :load-data="loadData"
            class="class-form-item"
            @on-change="hanldCourseChang"
          ></Cascader>
          <div style="color:gray">
            选择课程商品的分类，帮助家长快速筛选。
            注意：修改对应资源的课程类型，不会同步到课程资源管理中。
          </div>
        </FormItem>
        <!--  -->
        <FormItem v-if="showCourseType" v-auth="'HANGING_COURSE_TYPE'" label="课程类型" prop="courseChannel">
          <Row>
            <!-- 课程渠道 0-机构课程 1-合作课程 2-平台课程 -->
            <Select
              v-model="courseInfo.courseChannel"
              style="width:180px"
              @on-change="handleChangeCourseChannel"
            >
              <Option
                value="0"
              >机构课程</Option>
              <Option
                value="1"
              >挂靠合作课程</Option>
            </Select>
            <span v-if="courseInfo.courseChannel==='1'&&hangingRuleIdInfo.ruleName" style="margin-left:20px;">{{ hangingRuleIdInfo.ruleName }}</span>
            <Button v-if="courseInfo.courseChannel==='1'" type="primary" style="margin-left:20px;" @click="handleSelectTriOrg">请选择对应合同的分账信息</Button>
          </Row>
        </FormItem>
      </Form>
    </div>
    <ChooseAndModal
      ref="chooseCourse"
      modal-title="选择课程商品"
      :table-column="courseListColumn"
      :table-data="courseGoodsList"
      :table-total="coursePageInfo.total"
      :table-current="coursePageInfo.pageNum"
      :modal-width="80"
      :loading="loadingCourse"
      @emitSelectData="getSelectCourseRow"
      @pageChange="handlePageChange"
    >
      <div class="search-line">
        <Input
          v-model="courseSearchData.courseName"
          class="search-input"
          placeholder="资源名称"
        ></Input>

        <span style="margin-right: 16px" class="flex flexac">{{
          courseInfo.termName
        }}</span>

        <!-- <Cascader
          ref="yearTerms"
          v-model="yearTerms"
          class="search-select"
          placeholder="课程资源学期"
          :data="termList"
          @on-visible-change="getInitialData"
        ></Cascader> -->
        <!-- <Select
          v-if="portOrg !== 3"
          v-model="courseSearchData.orgId"
          filterable
          :remote-method="getApplyList"
          :loading="loadingApply"
          placeholder="资源提供方"
          class="search-input"
        >
          <Option v-for="item in applyList" :key="item.id" :value="item.id">{{
            item.orgName
          }}</Option>
        </Select> -->

        <choose-apply
          v-if="portOrg !== 3"
          ref="chooseApplyRef"
          :placeholder="`资源提供方`"
          class="search-select"
          @on-change="handleOnApplyChange"
        ></choose-apply>
        <Select
          v-model="courseSearchData.trainingType"
          class="search-input"
          placeholder="资源类别"
        >
          <Option
            v-for="item in courseTypeList"
            :key="item.id"
            :value="item.id"
          >{{ item.name }}</Option>
        </Select>
        <Button type="primary" @click="handleGetSearchValue">搜索</Button>
        <Button class="reset-btn" @click="handleResetSearch">重置</Button>
      </div>
    </ChooseAndModal>
    <Modal
      v-model="modalShow"
      :width="800"
      title="课程相关合同、分账配置"
      :footer-hide="true"
      :closable="false"
      @on-visible-change="ruleModalChange"
    >
      <div class="search-line">
        <span style="margin-right: 10px;">{{ courseInfo.termName }}</span>
        <Input
          v-model="divideRuleName"
          class="search-input"
          placeholder="请输入分账ID/分账名称"
        ></Input>
        <ChooseProvider v-if="authMap['HANGING_COURSE_TYPE']==1" ref="chooseHangingInfoProvideRef" class="search-input"></ChooseProvider>
        <Button type="primary" @click="handleSearchTriOrg">搜索</Button>
      </div>
      <RadioOrCheckboxTable
        :single-select-data.sync="selectOrgDataModal"
        :table-column="triOrgTableColumn"
        :table-data="triOrgData"
        :table-total="orgPageInfo.total"
        :table-current="orgPageInfo.pageNum"
        :table-loading="tableLoading"
        unique-key="ruleId"
      ></RadioOrCheckboxTable>
      <div class="modal-footer">
        <Button @click="handleCancleBtn">取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import ChooseAndModal from '@c/ChooseAndModal.vue';
import courseCenter from '@/request/courseCenter/index.js';
import schoolAdmin from '@/request/schoolAdmin/index.js';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import common from '@/request/common';
import { courseLevelStrList } from '@/utils/dictionary.js';
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary';
import { getGradeMinAndMax } from '@/utils/utils';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable.vue';
// import { courseInfoRequired } from '../data/addCommodityPiece';
import ChooseSchoolForForm from '@c/searchBlock/ChooseSchoolForForm';
import ChooseProvider from '@c/searchBlock/ChooseProvider.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
export default {
  components: {
    ChooseAndModal,
    ChooseApply,
    ChooseSchoolForForm,
    RadioOrCheckboxTable,
    ChooseProvider,
    CascaderYearTerms
  },
  inject: ['AddCommodityInstance'],
  props: {
    isCopy: {
      type: Boolean,
      default: false
    },
    classroomId: {
      type: String,
      default: ''
    }, // 课程商品Id(编辑的时候有)
    // firstLoad: {
    //   type: Boolean,
    //   default: false
    // },
    value: {
      type: Object,
      default: () => {
        return {
          schoolId: '', // 服务学校id
          schoolName: '', // 学校名称
          areaCode: '',
          branchId: '', // 校区id (courseClassExtAddRO schBranchId)
          branchName: '', // 校区名称
          courseId: '', // 课程资源id
          courseName: '', // 课程资源名称
          termCode: '', // 年度学期id
          yearCode: '',
          termName: '', // 年度学期名称
          classroomName: '', // 课班名称
          courseTypeId: [], // 课程资源类型id
          courseTypeName: '',
          courseChannel: '0', // 课程渠道 0-机构课程 1-合作课程 2-平台课程
          hangingRuleId: ''
        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    }, // 校验是否通过
    classHourInfo: {
      type: Object,
      default: () => { }
    },
    courseDetailInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    // 推荐年级
    const filterGradeStr = (row) => {
      return getGradeMinAndMax(row.gradeMin, row.gradeMax, true);
    };

    return {

      campusList: [], // 校区列表
      /** ===== 开班学校 start =====**/
      schoolName: '', // 学校名称（搜索用的）
      schoolListColumn: [
        {
          title: '学校名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '所属行政区',
          key: 'areaName',
          minWidth: 200
        }
      ], // 学校列表表格column
      schoolList: [], // 学校数据列表
      schoolPageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      }, // 学校数据的page信息
      selectSchoolData: {}, // 选择到的学校数据
      /** ===== 开班学校 end =====**/
      schoolAreaList: [], // 校区列表
      /** ===== 课程商品 start =====**/
      courseTypeList: [
        {
          name: '素质课',
          id: 1
        },
        {
          name: '基础托管',
          id: 2
        }
      ], // 课程类别
      courseType: ['默认', '素质课', '基础托管'],
      yearTerms: [], // 课程资源学期选择的学期
      termList: [], // 课程资源学期
      courseListColumn: [
        {
          title: '课程资源名称',
          key: 'courseName',
          minWidth: 150
        },
        {
          title: '课程资源学期',
          key: 'yearTermName',
          minWidth: 150
        },
        {
          title: '资源类别',
          key: 'trainingType',
          width: 158,
          render: (h, params) => {
            return h('div', [
              params.row.trainingType
                ? this.courseType[params.row.trainingType]
                : ''
            ]);
          }
        },
        {
          title: '资源级别',
          key: 'courseLevel',
          width: 158,
          render: (h, params) => {
            return h('div', [
              params.row.courseLevel
                ? courseLevelStrList[params.row.courseLevel]
                : '-'
            ]);
          }
        },
        {
          title: '推荐年级',
          key: 'gradeMin',
          width: 238,
          render: (h, params) => {
            return h('div', [
              filterGradeStr(params.row)
            ]);
          }
        },
        {
          title: '资源提供方',
          key: 'orgName',
          minWidth: 150
        }
      ], // 课程商品表格column
      courseGoodsList: [], // 课程商品列表
      courseSearchData: {
        yearCode: null,
        termCode: null,
        courseName: null, // 课程名称
        orgId: null, // 课程提供方
        trainingType: null, // 课程类别
        isShelves: 1
      },
      coursePageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      }, // 课程商品数据的page信息
      selectCourseGoodsData: {}, // 选择的课程商品数据
      /** ===== 课程商品 end =====**/
      portOrg: -1,
      loadingApply: false,
      applyList: [],
      loading: false,
      courseTypeId: '',

      courseTypeListAnother: [], // 课程分类
      courseTypeListData: [
        {
          value: '1',
          label: '素质课程',
          loading: false,
          children: []
        },
        {
          value: '2',
          label: '托管',
          loading: false,
          children: []
        }
      ],
      changeOnSelect: false,
      courseTypeIdShow: false,
      trainingType: '',
      quelityTypeList: quelityTypeList.slice(1, quelityTypeList.length), // 课程类型-素质
      hostingTypeList: hostingTypeList.slice(1, hostingTypeList.length), // 课程类型-基础托管
      courseTypePageInfo: {
        total: 0,
        pageSize: 100,
        pageNum: 1
      }, // 课程分类页码信息
      courseInfoRequired: {},
      firstLoad: true,
      loadingCourse: false,
      modalShow: false,
      selectOrgDataModal: {},
      hangingRuleIdInfo: {},
      triOrgTableColumn: [
        {
          title: '分账规则ID',
          key: 'ruleId',
          minWidth: 200
        },
        {
          title: '挂账分账名称',
          key: 'ruleName',
          minWidth: 200
        },
        {
          title: '三方课程机构',
          key: 'goodsProviderName',
          minWidth: 200
        },
        {
          title: '课程挂靠方',
          key: 'hangingOrgName',
          minWidth: 200
        },
        {
          title: '关联合同信息',
          key: 'contractName',
          minWidth: 200
        }
      ],
      triOrgData: [],
      orgPageInfo: {
        total: 0,
        pageSize: 10,
        pageNo: 1
      },
      divideRuleName: '',
      providerId: '',
      tableLoading: false,
      showCourseType: false
    };
  },
  computed: {
    ...mapState(['userInfo', 'authMap']),
    ...mapGetters(['theUserIdentity']),
    courseInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }, // 课程信息
    courseInfoRule() {
      //
      if (this.portOrg === 0 && +this.authMap['HANGING_COURSE_TYPE'] === 1 && this.courseInfo.courseTypeId && this.courseInfo.courseTypeId.length > 1 && +this.courseInfo.courseTypeId[0] === 1) {
        return {
          schoolId: [
            { required: true, message: '请选择开班学校', trigger: 'change' }
          ],
          branchId: [
            { required: true, message: '请选择指定校区', trigger: 'change' }
          ],
          courseId: [
            { required: true, message: '请选择课程资源', trigger: 'change' }
          ],
          termCode: [
            { required: true, validator: this.validateTermCode, trigger: 'change' }
          ],
          classroomName: [
            { required: true, message: '请输入商品名称', trigger: 'blur' }
          ],
          courseTypeId: [
            {
              required: true,
              type: 'array',
              message: '请选择分类',
              trigger: 'blur'
            }
          ],
          courseChannel: [
            { required: true, validator: this.validateCourseChannel, trigger: 'blur' }
          ]
        };
      } else {
        return {
          schoolId: [
            { required: true, message: '请选择开班学校', trigger: 'change' }
          ],
          branchId: [
            { required: true, message: '请选择指定校区', trigger: 'change' }
          ],
          courseId: [
            { required: true, message: '请选择课程资源', trigger: 'change' }
          ],
          termCode: [
            { required: true, validator: this.validateTermCode, trigger: 'change' }
          ],
          classroomName: [
            { required: true, message: '请输入商品名称', trigger: 'blur' }
          ],
          courseTypeId: [
            {
              required: true,
              type: 'array',
              message: '请选择分类',
              trigger: 'blur'
            }
          ]
        };
      }
    }

  },
  watch: {
    // firstLoad(newVal) {
    //   if (newVal && this.classroomId) {
    //     this.getCourseTypeInit();
    //   }
    // },
    trainingType(newVal) {
      if (newVal) {
        this.courseTypeListData = [
          {
            value: '1',
            label: '素质课程',
            loading: false,
            children: []
          },
          {
            value: '2',
            label: '托管',
            loading: false,
            children: []
          }
        ];
        this.courseTypeIdShow = true;
      }
    },
    'courseInfo.schoolId'(newVal) {
      this.getBranchList();
    },
    'courseInfo.courseId'(newVal) {
      if (newVal) {
        // 请求课程资源
        this.getCourseDetail();
      }
    },
    'courseInfo.courseTypeId': {
      deep: true,
      handler(newVal, oldVal) {
        if (+this.authMap['HANGING_COURSE_TYPE'] === 1) {
          if (newVal && newVal.length > 1 && +newVal[0] === 1) {
            this.showCourseType = true;
          } else {
            this.showCourseType = false;
            this.courseInfo.courseChannel = '0';
            this.hangingRuleIdInfo = {};
            this.courseInfo.hangingRuleId = '0';
          }
        }
      }
    },
    courseInfoRule(newVal) {
      const obj = {};
      Object.keys(this.courseInfoRule).forEach((item) => {
        obj[item] = this.courseInfoRequired[item] || { require: !!this.courseInfoRule[item][0].required,
          status: false };
      });
      this.courseInfoRequired = obj;
      this.$nextTick(() => {
        this.courseInfoRequired['courseChannel'] ? this.$refs.courseInfo.validateField('courseChannel') : '';
      });
    }
  },
  created() {
    // 学校的，学校id有的
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.dealFormRequire();
    if (this.portOrg === 2) {
      this.courseInfo.schoolId = this.userInfo.orgId;
    }
  },
  mounted() {
    this.AddCommodityInstance.findRuleRequireNewCourse(
      this,
      'courseInfo',
      '课程信息'
    );
  },
  methods: {
    setTerm() {
      this.$refs.cascaderYearTerms.yearTerms = [this.courseInfo.yearCode, '' + this.courseInfo.termCode];
    },
    // 校验课程类型
    validateCourseChannel(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择课程类型'));
      } else if (value === '1' && (!this.hangingRuleIdInfo.ruleId || this.hangingRuleIdInfo.ruleId === '0')) {
        callback(new Error('请选择对应合同的分账信息'));
      } else {
        callback();
      }
    },
    validateTermCode(rule, value, callback) {
      if (this.courseInfo.termCode) {
        callback();
      } else {
        callback(new Error('请选择年度学期'));
      }
    },
    ruleModalChange(status) {
      if (!status) {
        this.selectOrgDataModal = this.hangingRuleIdInfo;
      }
    },
    handleChangeCourseChannel(value) {
      if (value !== '1') {
        this.hangingRuleIdInfo = {};
        this.courseInfo.hangingRuleId = '0';
      }
    },
    handleCancleBtn() {
      this.modalShow = false;
    },
    handleSureBtn() {
      this.hangingRuleIdInfo = this.selectOrgDataModal;
      this.courseInfo.hangingRuleId = this.hangingRuleIdInfo.ruleId;
      this.modalShow = false;
      this.$refs.courseInfo.validateField('courseChannel');
    },
    handleSearchTriOrg() {
      this.providerId = this.$refs.chooseHangingInfoProvideRef ? this.$refs.chooseHangingInfoProvideRef.orgId : '';
      this.orgPageInfo.pageNo = 1;
      this.getHangingDivideRulesList();
    },
    handleSelectTriOrg() {
      if (!this.courseInfo.termCode) {
        this.$Message.error('请先选择年度学期');
        return;
      }
      if (!this.courseInfo.courseTypeId || this.courseInfo.courseTypeId.length === 0) {
        this.$Message.error('请先选择课程分类');
        return;
      }
      this.$refs.chooseHangingInfoProvideRef ? this.$refs.chooseHangingInfoProvideRef.orgId = '' : '';
      this.handleSearchTriOrg();

      this.modalShow = true;
    },
    // 获取挂靠分账规则列表
    async getHangingDivideRulesList() {
      const params = {
        pageNo: this.orgPageInfo.pageNo,
        pageSize: this.orgPageInfo.pageSize,
        hangingEnable: 1,
        divideEnable: 1,
        yearCode: this.courseInfo.yearCode,
        termCode: this.courseInfo.termCode,
        hangingOrgId: this.courseInfo.orgId,
        schoolId: this.courseInfo.schoolId
      };
      if (this.courseInfo.courseTypeId && this.courseInfo.courseTypeId.length > 1) {
        params.offerType = +this.courseInfo.courseTypeId[0] === 1 ? 1 : +this.courseInfo.courseTypeId[0] === 2 ? 3 : '';// 支持的商品类型 1-素质课 3-托管课 4-材料
      }
      if (this.providerId) {
        params.providerId = this.providerId;
      }
      if (this.divideRuleName) {
        params.divideRuleName = this.divideRuleName;
      }

      this.tableLoading = true;
      try {
        const res = await common.getHangingDivideRulesListApi(params);
        if (res.status === 200) {
          this.triOrgData = res.message.list;
          this.orgPageInfo.total = +res.message.total;
        }
      } finally {
        this.tableLoading = false;
      }
    },
    getFormValidate(prop, status, error) {
      // console.log('校验表单');
      this.courseInfoRequired[prop].status = status;
      this.AddCommodityInstance.findRuleRequireNewCourse(
        this,
        'courseInfo',
        '课程信息'
      );
    },
    dealFormRequire() {
      Object.keys(this.courseInfoRule).forEach((item) => {
        this.courseInfoRequired[item] = {
          require: !!this.courseInfoRule[item][0].required,
          status: false
        };
      });
    },
    handleToCourseTypePage() {
      const { href } = this.$router.resolve({
        name: 'courseCenter_resources_courseTable_edit',
        query: { courseId: this.courseInfo.courseId }
      });
      window.open(href);
    },
    async getCourseTypeInit() {
      this.$nextTick(async() => {
        await this.getTapList(this.courseInfo.courseTypeId[0]);
        this.courseTypeKind = this.courseInfo.courseTypeId[1];
        await this.getCourseType();
        console.log('首次加载数据==============');
        this.courseTypeIdShow = true;
        setTimeout(() => {
          this.$refs.cascaderBox.updateSelected();
        }, 1000);
      });
    },
    handleTrimValue(keyName) {
      if (!keyName) {
        return null;
      }
      this.courseInfo[keyName] = this.courseInfo[keyName].trim();
    },
    // 校验表单
    checkForm() {
      this.$refs.courseInfo.validate();
    },
    // 打开弹窗
    openModal(name, id) {
      this.$refs[name].open(id);
    },
    // 关闭弹窗
    closeModal(name) {
      this.$refs[name].close();
    },
    /** === 有关选择学校start ===**/
    // 获取选择的学校数据
    getSelectSchoolRow(row) {
      this.courseInfo.schoolId = row.orgId;
      this.courseInfo.schoolName = row.name;
      this.courseInfo.areaCode = row.areaCode;
      if (
        (process.env.NODE_ENV === 'production' ||
          process.env.NODE_ENV === 'development') &&
        (row.orgId === '681611867042402304' ||
          row.orgId === '614867741949562880' ||
          row.orgId === '701006079886184448')
      ) {
        this.courseInfo.areaCode = '440114';
      }
      this.selectSchoolData = row;
      this.courseInfo.courseId = '';
      // this.courseInfo.termId = '';
      this.courseInfo.orgId = '';
      // 选择学校id之后，需要表单需要校验的
      this.courseInfoRequired['courseId'].status = false;
      // this.courseInfoRequired['termId'].status = false;
      this.$refs.courseInfo.validateField('schoolId');
      this.$refs.courseInfo.validateField('branchId');
    },
    /** === 有关选择学校end ===**/
    /** === 有关选择校区start ===**/
    // 查询校区列表
    async getBranchList() {
      const res = await schoolAdmin.getBranchList({
        orgId: this.courseInfo.schoolId
      });
      if (res.status === 200) {
        this.campusList = res.message;
        if (this.courseInfo.branchId === '') {
          this.courseInfo.branchId = this.campusList[0].branchId;
          this.courseInfo.branchName = this.campusList[0].branchName;
        }
      }
    },
    getBranchName(id) {
      const obj = this.campusList.find((item) => {
        return item.branchId === id;
      });
      if (obj) {
        this.courseInfo.branchName = obj.branchName;
      }
    },
    /** === 有关选择校区end ===**/
    /** === 有关选择学期start ===**/
    getTermName(name) {
      this.courseInfo.termName = name;
    },
    getTermChange(e) {
      if (e && e.length === 2) {
        this.courseInfo.yearCode = e[0];
        this.courseInfo.termCode = e[1];
      } else {
        this.courseInfo.yearCode = '';
        this.courseInfo.termCode = '';
      }
      this.courseInfo.courseId = '';
      // this.courseInfo.courseName = row.courseName;
      this.courseInfo.orgId = '';
      this.courseInfo.orgName = '';
      this.courseInfoRequired['courseId'].status = false;
    },
    /** === 有关选择学期end ===**/
    /** === 有关选择课程start ===**/
    // 搜索框 学期列表
    async getyearTermsListFun(newval) {
      return new Promise(async(resolve, reject) => {
        // 学校
        const res = await courseCenter.getDataSearchYearList();
        try {
          if (res.status === 200) {
            const dictValue = JSON.parse(res.message.dictValue);
            const termList = [];

            dictValue.forEach((item) => {
              // console.log(item);
              termList.push({
                value: item.sort,
                label: item.value,
                children: [
                  {
                    value: '1',
                    label: '第一学期'
                  },
                  {
                    value: '2',
                    label: '第二学期'
                  }
                ]
              });
            });
            this.termList = termList;
            resolve();
          }
        } catch (err) { }
      });
    },
    // 学期 展开 默认值
    getInitialData(status) {
      if (status && this.yearTerms.length == 0) {
        const nowSelect = this.getNowDayInfo();
        const newYear = this.termList.find(
          (item) => nowSelect === item.label
        ).value;
        this.yearTerms = [newYear, ''];
        this.$nextTick(function() {
          const parentEle = this.$refs.yearTerms.$children[3].$el;
          const target = parentEle.getElementsByClassName(
            'ivu-cascader-menu-item-active'
          )[0];
          const parent = parentEle.getElementsByClassName('ivu-cascader-menu')[0];
          parent.scrollTo(0, target.offsetTop - parent.offsetTop);
        });
      }
    },
    // 计算月份
    getNowDayInfo() {
      const nowTime = new Date();
      const year = nowTime.getFullYear();
      const month = nowTime.getMonth() + 1;
      const date = nowTime.getDate();
      if (month > 8 || (month === 8 && date >= 15)) {
        return `${year}-${year + 1}`;
      } else {
        return `${year - 1}-${year}`;
      }
    },
    // 打开选择课程弹窗
    async getCourseList() {
      const params = {
        schoolId: this.courseInfo.schoolId,
        pageNum: this.coursePageInfo.pageNum,
        pageSize: this.coursePageInfo.pageSize
        // isFillerSchool: 1
      };
      const paramsTrue = Object.assign(params, this.courseSearchData);
      if (this.yearTerms.length === 2) {
        paramsTrue.yearCode = this.yearTerms[0];
        paramsTrue.termCode = this.yearTerms[1];
      }
      this.loadingCourse = true;
      const res = await courseCenter.getClassCoursePage(paramsTrue);
      this.loadingCourse = false;
      if (res.status === 200) {
        this.courseGoodsList = res.message.list.map((item) => {
          // item.classTimeShow = dealTimeList(item);
          item.id = item.courseId;
          return item;
        });
        this.coursePageInfo.total = Number(res.message.total);
      }
    },
    handlePageChange(page) {
      this.coursePageInfo.pageNum = page;
      this.getCourseList();
    },
    async handleOpenCourse(id) {
      if (this.courseInfo.schoolId === '') {
        this.$Message.error('请先选择学校!');
        return;
      }
      if (this.courseInfo.termCode === '') {
        this.$Message.error('请先选择学期!');
        return;
      }
      this.yearTerms = [this.courseInfo.yearCode, '' + this.courseInfo.termCode];

      // await this.getyearTermsListFun();

      this.coursePageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.getCourseList();

      this.openModal('chooseCourse', id);

      // if (this.portOrg !== 3) {
      //   this.getApplyList();
      // }
    },
    // 获取选择到的课程
    getSelectCourseRow(row) {
      this.courseInfo.courseId = row.courseId;
      // this.courseInfo.courseName = row.courseName;
      this.courseInfo.orgId = row.orgId;
      this.courseInfo.orgName = row.orgName;
      // this.courseInfo.areaCode = row.areaCode;
      // this.selectCourseGoodsData = row;
      // console.log(row, '选择的课程0--0-0--');
      this.courseInfo.courseTypeId = [];
      // 选择课程id之后，需要表单需要校验的
      this.$refs.courseInfo.validateField('courseId');
      this.$refs.courseInfo.validateField('courseTypeId');

      // 选择了课程资源后需要回显的----
      const obj = JSON.parse(JSON.stringify(this.classHourInfo));

      obj.gradeMin = row.gradeMin;
      obj.gradeMax = row.gradeMax;
      this.$emit('update:classHourInfo', obj);
      console.log('this.courseInfo', this.courseInfo);
    },
    /** === 有关选择课程end ===**/
    // 请求提供方列表
    handleOnApplyChange(val) {
      this.courseSearchData.orgId = val.orgId;
    },
    // async getApplyList(name) {
    //   const params = {
    //     pageNum: 1,
    //     pageSize: 100
    //   };
    //   name ? (params.orgName = name) : '';
    //   this.loadingApply = true;
    //   const res = await courseCenter.getListCourseOrder(params);
    //   if (res.status === 200) {
    //     this.applyList = res.message.list.map((item) => {
    //       item.id = item.orgId;
    //       return item;
    //     });
    //     this.loadingApply = false;
    //   }
    // },
    hanldCourseChang(value, selectedData) {
      this.courseInfo.courseTypeId = value;
      this.$refs.courseInfo.validateField('courseTypeId');
    },
    async loadData(item, callback) {
      console.log('加载数据loaddata', item);
      // 获取二级
      if (item.label === '素质课程' || item.label === '托管') {
        item.loading = true;
        await this.getTapList(item.value);
        item.loading = false;
        if (this.loading) {
          delete item.loading;
        }
        callback();
      } else {
        item.loading = true;
        this.courseTypeKind = item.value;
        // 获取三级
        await this.getCourseType();
        item.children = this.courseTypeListAnother;
        item.loading = false;
        callback();
        this.classroomId && this.firstLoad
          ? this.$refs.cascaderBox.updateSelected()
          : '';
        this.firstLoad = false;
        console.log('loaddata加载三级数据-------', this.firstLoad);
        // callback();
      }
      // if (this.changeOnSelect) {
      //   callback();
      // }
    },
    // 课程分类三级列表
    async getCourseType() {
      let params = {};
      switch (this.theUserIdentity) {
        // 当是机构端的时候 - orgId 传学校ID或者教育局ID
        case 'org':
          params = {
            orgId: this.courseInfo.schoolId,
            courseTypeKind: this.courseTypeKind
          };
          break;
        default:
          params = {
            orgId: this.courseInfo.schoolId,
            courseTypeKind: this.courseTypeKind
          };
          break;
      }
      const res = await courseCenterApi.getCourseTypeTapList(params);
      if (res.status === 200) {
        if (res.message.length) {
          res.message.forEach((ele) => {
            ele.value = ele.courseTypeId;
            ele.label = ele.courseTypeName;
          });
          this.courseTypeListAnother = res.message;
        } else {
          this.courseTypeListAnother = [];
        }
      }
    },
    // 课程分类二级列表
    async getTapList(type) {
      const params = {
        orgId: this.courseInfo.schoolId,
        courseTypeAttr: type
      };
      const res = await courseCenterApi.getTapList(params);
      // console.log('res', res);
      if (res.status === 200) {
        if (res.message.length) {
          if (+type === 1) {
            const quelityTypeList = [];
            this.quelityTypeList.forEach((ele) => {
              res.message.forEach((item) => {
                if (ele.value == item) {
                  quelityTypeList.push(ele);
                }
              });
            });
            quelityTypeList.forEach((ele) => {
              ele.children = [];
              ele.loading = false;
            });
            this.courseTypeListData.length > 0
              ? (this.courseTypeListData[0].children = quelityTypeList)
              : '';
          } else {
            const hostingTypeList = [];
            this.hostingTypeList.forEach((ele) => {
              res.message.forEach((item) => {
                if (ele.value == item) {
                  hostingTypeList.push(ele);
                }
              });
            });
            hostingTypeList.forEach((ele) => {
              ele.children = [];
              ele.loading = false;
            });
            console.log(
              hostingTypeList,
              '托管的------',
              this.courseTypeListData,
              this.courseTypeListData[1]
            );
            this.courseTypeListData[1].children = hostingTypeList;
          }
        } else {
          this.loading = true;
        }
      }
    },
    hanldCourse() {
      if (!this.courseInfo.courseName) {
        this.$Message.error('请先选择课程资源！');
      }
    },
    async getCourseDetail() {
      const res = await courseCenterApi.getCourseDetail({
        courseId: this.courseInfo.courseId
      });
      if (res.status === 200 && !this.classroomId) {
        const { courseCover, courseDescribe, courseAchievement } = res.message;
        const obj = {
          courseCover,
          context: courseDescribe,
          courseAchievement,
          courseNotice: this.courseDetailInfo.courseNotice
        };
        if (obj.courseCover && obj.courseCover !== '0') {
          obj.courseCoverShow = {
            fileId: obj.courseCover,
            file: null,
            imgShow: ''
          };
        }
        obj.courseAchievementShow = obj.courseAchievement
          ? obj.courseAchievement.split(',').map((item) => {
            return {
              fileId: item,
              file: null,
              imgShow: ''
            };
          })
          : [];
        this.$emit('update:courseDetailInfo', obj);

        this.selectCourseGoodsData = {
          courseId: res.message.courseId,
          courseTypeName: res.message.courseTypeName,
          orgName: res.message.orgName,
          orgId: res.message.orgId
        };
        this.courseInfo.courseTypeName = res.message.courseTypeName;
        this.courseInfo.courseName = res.message.courseName;
        this.trainingType = res.message.trainingType; // 1
        this.courseTypeKind = res.message.courseTypeKind; // 2
        this.courseTypeId = res.message.courseTypeId; // 3
      } else if (res.status === 200) {
        this.selectCourseGoodsData = {
          courseId: res.message.courseId,
          courseTypeName: res.message.courseTypeName,
          orgName: res.message.orgName,
          orgId: res.message.orgId
        };
        // this.courseOrgName = res.message.orgName;
        // this.courseTypeName = this.courseType[res.message.trainingType];
        this.courseInfo.courseTypeName = res.message.courseTypeName;
        this.courseInfo.courseName = res.message.courseName;
        this.trainingType = res.message.trainingType;
        this.courseTypeKind = res.message.courseTypeKind;
        this.courseTypeId = res.message.courseTypeId;
      }
    },
    handleGetSearchValue() {
      this.coursePageInfo.pageNum = 1;
      this.coursePageInfo.total = 0;
      this.getCourseList();
    },
    handleResetSearch() {
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.courseSearchData = {
        courseName: null, // 课程名称
        orgId: null, // 课程提供方
        trainingType: null, // 课程类别
        isShelves: 1
      };

      this.coursePageInfo.pageNum = 1;
      this.coursePageInfo.total = 0;
      this.getCourseList();
    }
  }
};
</script>
<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.select-big {
  display: flex;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  width: 280px;
  margin-right: 16px;
  /deep/.ivu-select-selection {
    border: none;
  }
  /deep/.ivu-input {
    border: none;
    border-radius: 0;
    border-left: 1px solid #dcdee2;
  }
  /deep/.ivu-input:focus {
    box-shadow: none;
  }
}
.reset-btn {
  margin-left: 16px;
}
.class-info-block {
  cursor: pointer;
}
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 200px;
    margin-right: 16px;
  }
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button + button {
    margin-left: 8px;
  }
}
</style>
